// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolConfigVersionId } from './BrewcontrolConfigVersion';
import { brewcontrolNodeId } from './BrewcontrolNode';
import { z } from 'zod';
export const brewcontrolDeviceSnapshot = z.object({
    version_id: brewcontrolConfigVersionId,
    node_id: brewcontrolNodeId,
    content_hash: z.string(),
    observed_at: z.date(),
    signals: z.unknown(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const brewcontrolDeviceSnapshotInitializer = z.object({
    version_id: brewcontrolConfigVersionId,
    node_id: brewcontrolNodeId,
    content_hash: z.string(),
    observed_at: z.date(),
    signals: z.unknown(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const brewcontrolDeviceSnapshotMutator = z.object({
    version_id: brewcontrolConfigVersionId.optional(),
    node_id: brewcontrolNodeId.optional(),
    content_hash: z.string().optional(),
    observed_at: z.date().optional(),
    signals: z.unknown().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=BrewcontrolDeviceSnapshot.js.map